// extracted by mini-css-extract-plugin
module.exports = {"inputHolder":"styles_inputHolder__6zcY4","listnumborder":"styles_listnumborder__Zt17F"};